import { AdminDatasetAccessLevel } from "admin/types/interfaces/adminDataset";
import { Badge, BadgeProps } from "~/components/ui/badge";

interface AccessBadgeConfig {
  label: string;
  variant: BadgeProps["variant"];
}

const ACCESS_BADGE_CONFIG: Record<AdminDatasetAccessLevel, AccessBadgeConfig> = {
  owner: { label: "Owner", variant: "default" },
  analyze: { label: "Analyst", variant: "secondary" },
  preview: { label: "Preview", variant: "outline" },
  "no access": { label: "No access", variant: "muted" },
};

interface DatasetAccessBadgeProps {
  accessLevel: AdminDatasetAccessLevel;
}

const DatasetAccessBadge = ({ accessLevel }: DatasetAccessBadgeProps) => {
  const config =
    ACCESS_BADGE_CONFIG[accessLevel] ?? ACCESS_BADGE_CONFIG[AdminDatasetAccessLevel.NONE];
  return <Badge variant={config.variant}>{config.label}</Badge>;
};

export default DatasetAccessBadge;
